export default __webpack_public_path__ + "static/media/feed3.c1411e20.jpg";